import Vue from 'vue';
import FilterUtility from "../utility/FilterUtility";

Vue.component('mobile-filter-button', {
    template: `#mobile-filter-button`,
    delimiters: ['[[', ']]'],

    data() {
        return {
            filterCount: this.GetFilterCount(),
        };
    },
    mounted() {

    },
    methods: {
        HandleClick()
        {
            EventManager.fire('mobile-filter-open');
        },
        GetFilterCount()
        {
            let selectedFilters = FilterUtility.GetSelectedFilters();

            let filterCount = 0;

            if(selectedFilters.brands.length > 0)
            {
                filterCount++;
            }

            if(selectedFilters.productLines.length > 0)
            {
                filterCount++;
            }

            filterCount += Object.keys(selectedFilters.features).length;

            return filterCount;
        }
    }
});